import { render, staticRenderFns } from "./TemplateFullscreen.vue?vue&type=template&id=26801702"
import script from "./TemplateFullscreen.vue?vue&type=script&lang=js"
export * from "./TemplateFullscreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports